import { render, staticRenderFns } from "./FormNormativo.vue?vue&type=template&id=0156594a&scoped=true&"
import script from "./FormNormativo.vue?vue&type=script&lang=ts&"
export * from "./FormNormativo.vue?vue&type=script&lang=ts&"
import style0 from "./FormNormativo.vue?vue&type=style&index=0&id=0156594a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0156594a",
  null
  
)

export default component.exports